// Centralized plan -> settings mapping
export function resolvePlanDefaults(plan, defaultProductionOutput = 100) {
  const key = String(plan || "").toLowerCase();
  const mapping = {
    studio: { productionOutput: 411, studioComplexityFactor: 1.0 },
    studio_annual: { productionOutput: 600, studioComplexityFactor: 0.95 },
    free: { productionOutput: defaultProductionOutput, studioComplexityFactor: 1.0 },
  };
  return mapping[key] || mapping.studio;
}

export default { resolvePlanDefaults };
// Centralized plan -> settings mapping
// Used by App and BillingSuccess to apply plan defaults consistently.

export function planToSettings(planKey, defaultProductionOutput = 100) {
  const key = String(planKey || "").toLowerCase();
  const mapping = {
    studio: { productionOutput: 411, studioComplexityFactor: 1.0 },
    studio_annual: { productionOutput: 600, studioComplexityFactor: 0.95 },
    free: { productionOutput: defaultProductionOutput, studioComplexityFactor: 1.0 },
  };
  return mapping[key] || mapping.studio;
}

export const KNOWN_PLANS = ["free", "studio", "studio_annual"];
